<template>
  <div>
    <SampleSearchForm
      ref="sampleSearchForm"
      :listForm="searchList"
      @handlerSearch="onSearch"
      @clear-search="clearSearch"
    />
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      :showCheckbox="false"
      @page-size-change="pageSizeChange"
      @sort-change="sortChange"
    >
      <!-- 产品信息 -->
      <template #idProductName="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <div>产品ID：{{ row.productId }} </div>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">
              容量：{{ row.capacity }}{{ row.unit }}
            </div>
          </div>
        </div>
      </template>
      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
      <!-- 采用结果 -->
      <template #isUseSlot="{ row }">
        <div>
          <span>
            {{ row.isUse ? (row.isUse === 'YES' ? '采用' : '不采用') : '' }}
          </span>
          <el-tooltip
            v-if="row.reason"
            effect="dark"
            :content="row.reason"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
      <!-- 状态 -->
      <template #idStatus="{ row }">
        <div>
          <span>{{ row.statusName }}</span>
          <el-button
            type="text"
            v-if="['REJECT', 'LEADER_REJECT'].includes(row.status) && row.createBy === userInfo.id"
            @click="toUpdate(row)"
            class="sample-btn"
            v-hasPermission="'warehouse-sample-manage/sample-query-update'"
            >修改</el-button
          >
          <el-tooltip
            v-if="row.status === 'REJECT' || row.status === 'LEADER_REJECT'"
            effect="dark"
            :content="row.checkRemark || row.leadApprovalOpinion"
            placement="top"
          >
            <span class="sample-btn">查看原因</span>
          </el-tooltip>
        </div>
      </template>
    </CommonTable>

    <!-- 修改弹框 -->
    <el-dialog :visible.sync="dialogVisible" width="1350px">
      <ApplySample
        ref="sampleDialog"
        :listData="listData"
        @on-success="smapleSaveSuccess"
      />
    </el-dialog>
    <!-- 寻样详情 -->
    <el-dialog
      :visible.sync="productDialogVisible"
      width="650px"
      :title="'供应商：' + productInfo.supplierName"
    >
      <ApplySampleLeft :listData="productInfo" :isNumber="false" />
    </el-dialog>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="operationLogData" />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import ApplySample from '@/components/ApplySample';
import ApplySampleLeft from '@/components/ApplySampleLeft';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
export default {
  name: 'sample-query',
  components: { CommonTable, SampleSearchForm, ApplySample, ApplySampleLeft, SampleOperationLogDialog },
  props: {},
  data() {
    return {
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'DictSelect',
            type: 'cml_corder_status',
            label: '状态',
            prop: 'status',
            defaultValue: undefined,
            placeholder: '请选择状态',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
          {
            tag: 'el-input',
            label: '快递单号',
            prop: 'expressNo',
            defaultValue: undefined,
            placeholder: '请输入完整的快递单号',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请开始时间',
            prop: 'createDate',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
          {
            tag: 'el-date-picker',
            type: 'datetime',
            label: '申请结束时间',
            prop: 'createdDateEnd',
            defaultValue: undefined,
            placeholder: '请选择时间',
          },
        ],
      },
      listForm: {},
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      tableHeadTab: [
        {
          label: '产品名称',
          prop: 'productName',
          slotColumn: true,
          slotName: 'idProductName',
          width: 200,
          sortable: true
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140, sortable: true },
        { label: '申请人', prop: 'demandStaffName', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '供应商', prop: 'supplierName', sortable: true },
        { label: '样品类型', prop: 'sampleTypeName', width: 100, sortable: true },
        { label: '快递单号', prop: 'expressNo', width: 140 },
        {
          label: '采用结果',
          prop: 'isUse',
          slotColumn: true,
          slotName: 'isUseSlot',
          width: 120,
          sortable: true
        },
        {
          label: '状态',
          prop: 'statusName',
          slotColumn: true,
          slotName: 'idStatus',
          width: 200,
          sortable: true
        },
      ],
      tableDataTab: {},
      dialogVisible: false,
      productDialogVisible: false,
      userInfo: {},
      productInfo: [],
      listData: {},
      allUserData: [],
      operationLogData: {}
    };
  },
  created() {
    // const createDate = dayjs().subtract(3, 'month').format('YYYY-MM-DD HH:mm:ss');
    // const createdDateEnd = dayjs().format('YYYY-MM-DD HH:mm:ss');
    // this.searchList.list.find(item => item.prop === 'createDate').defaultValue = createDate;
    // this.searchList.list.find(item => item.prop === 'createdDateEnd').defaultValue = createdDateEnd;
    // this.listForm = { createDate, createdDateEnd };
  },
  mounted() {
    // 获取用户登录信息
    this.userInfo = this.$store.getters.userSelf.user;
    this.getList();
    this.getAllUser();
    this.$refs.CommonTable.changeHeight();
  },
  methods: {
    getAllUser() {
      // 添加申请人条件
      this.$http.setting.getUserListAll({ customerId: '0' }).then(res => {
        const item = {
          tag: 'el-select',
          label: '申请人',
          prop: 'demandStaff',
          defaultValue: undefined,
          placeholder: '请输入申请人名称',
          options: res.data.map(item => {
            return {
              label: item.loginName,
              value: item.id,
            };
          }),
        };
        if (['2', '1'].includes(this.$store.getters.userSelf.user.adminType)) {
          this.searchList.list.push(item);
        }
      });
    },
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      if(params.data.createDate && params.data.createdDateEnd && dayjs(params.data.createDate).diff(dayjs(params.data.createdDateEnd)) > 0) {
        this.$message.error('申请开始时间不能晚于申请结束时间');
        return;
      }
      this.tableLoading = true;
      this.$http.sample
        .getOrderList(params)
        .then(result => {
          this.tableDataTab = result.data;
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // 修改
    toUpdate(row) {
      this.dialogVisible = true;
      const data = {
        supplierName: row.supplierName,
        list: [row],
      };
      this.$nextTick(() => {
        this.listData = cloneDeep(data);
      });
    },
    // 详情
    toDetail(row) {
      this.productDialogVisible = true;
      this.productInfo = row;
    },
    // 提交索样申请
    smapleSaveSuccess() {
      this.dialogVisible = false;
      this.getList();
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.operationLogData = {
        supplierName: row.supplierName,
        list: [row],
      };
    },
    clearSearch() {
      this.$refs.CommonTable.clearSort();
      this.tableParamTab.orderBy = '';
      this.tableParamTab.data = {};
      this.listForm = {};
      this.getList();
    },
    sortChange(val) {
      const sortList = {
        productName: 'product_id',
        createDate: 'create_date',
        supplierName: 'supplier_name',
        sampleTypeName: 'sample_type',
        isUse: 'is_use',
        statusName: 'status',
      }
      const str = val.split(' ');
      this.tableParamTab.orderBy = sortList[str[0]] ? sortList[str[0]] + ' ' + str[1] : val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.sample-btn {
  cursor: pointer;
  color: #AB0033;
  margin: 0 7px;
}
.sample-info {
  display: flex;
  padding: 5px 0;
  img {
    margin-right: 5px;
  }
  img,
  div {
    span {
      color: #AB0033;
    }
  }
}
.product-info-box {
  height: 200px;
}
</style>
